<h3 color="primary" class="popup-header d-flex align-items-center justify-content-between">
  <span>{{title}}</span>
  <button style="float: right;" mat-button matSuffix mat-icon-button (click)="closeModalDialog()">
    <mat-icon>close</mat-icon>
  </button>
</h3>
<mat-dialog-content class="mat-typography">
  <div class="image-viewer-wrapper">
    <angular-image-viewer [src]="images" [(config)]="config" [(index)]="imageIndex" [screenHeightOccupied]='0'>
    </angular-image-viewer>
  </div>
</mat-dialog-content>